<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <router-link class="section" to="/contracts">
                Contratos
              </router-link>
              <i class="right chevron icon divider"></i>
              <router-link
                class="section"
                :to="`/contracts/${$route.params.contract_id}`"
              >
                {{ $route.params.contract_id }}
              </router-link>
              <i class="right chevron icon divider"></i>
              <router-link
                class="section"
                :to="`/contracts/${$route.params.contract_id}/invoices`"
              >
                <div class="neutral">Parcelas</div>
              </router-link>
              <i class="right chevron icon divider"></i>
              <div class="active section">{{ sectionName }}</div>
            </Breadcrumb>
          </div>
          <div v-show="persisted" class="eight wide right aligned column">
            <div class="actions">
              <router-link
                class="section"
                :to="`/contracts/${$route.params.contract_id}/invoices/new`"
              >
                <i class="plus icon"></i>
                Nova Parcela
              </router-link>
              <a @click.prevent="openHistory"
                ><i class="history icon"></i>Histórico</a
              >
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <HistoryModal ref="history" resource="Invoice" :item_id="form.id" />
      <form
        :class="['ui small', { error: anyError }, 'form']"
        v-autocomplete-off
      >
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="fields">
                <div
                  :class="[
                    'four wide required',
                    { error: errors.number },
                    'field'
                  ]"
                  :data-content="errorsTo('number')"
                >
                  <label for="invoice-form-number">Número</label>
                  <input
                    type="text"
                    id="invoice-form-number"
                    v-model="form.number"
                  />
                </div>
                <div
                  :class="[
                    'four wide required',
                    { error: errors.due_date },
                    'field'
                  ]"
                  :data-content="errorsTo('due_date')"
                >
                  <label for="invoice-form-due-date">Vencimento</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="invoice-form-due-date"
                    v-model="form.due_date"
                  />
                </div>
                <div
                  :class="[
                    'four wide',
                    { error: errors.date_of_payment },
                    'field'
                  ]"
                  :data-content="errorsTo('date_of_payment')"
                >
                  <label for="invoice-form-date-of-payment">Pagamento</label>
                  <input
                    type="text"
                    v-mask="'##/##/####'"
                    id="invoice-form-date-of-payment"
                    v-model="form.date_of_payment"
                  />
                </div>
                <div
                  :class="[
                    'four required wide',
                    { error: errors.amount },
                    'field'
                  ]"
                  :data-content="errorsTo('amount')"
                >
                  <label for="invoice-form-amount">Valor</label>
                  <money v-model="form.amount"></money>
                </div>
              </div>
              <div v-show="showPaymentRequestButton" class="fields">
                <div class="field">
                  <button
                    @click="requestPayment"
                    type="button"
                    name="requestPayment"
                    :class="['ui', { disabled: requestingPayment }, 'button']"
                  >
                    <i class="credit card icon"></i>Solicitar pagamento
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="save"
                  type="button"
                  name="save"
                  class="ui submit blue button"
                >
                  <i class="save icon"></i>Salvar
                </button>
                
                <a v-show="persisted" class="delete" @click.prevent="remove">
                  <i class="trash icon"></i>Remover Parcela
                </a>
                <a v-show="paid" class="warn" @click.prevent="chargeback">
                  <i class="reply icon"></i>Estornar Parcela
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import HistoryModal from '@/components/history_modal';

export default {
  components: { Breadcrumb, PageLayout, HistoryModal },

  watch: {
    $route() {
      if (_.isEmpty(this.$route.params.id)) {
        this.clearForm();
      }
    }
  },

  data() {
    return {
      loading: false,
      loadingCep: false,
      requestingPayment: false,
      errors: {},
      plans: [],
      currentMemberIndex: null,
      persistedDateOfPayment: null,
      form: {
        date: this.$moment().format('DD/MM/YYYY'),
        id: null,
        owner_id: null,
        owner_name: null,
        obs: null,
        members: [],
        amount: 0,
        payment_by_card: null,
        date_of_payment: null,
        late: null
      }
    };
  },

  computed: {
    persisted() {
      return this.form.id != null;
    },

    paid() {
      return this.form.id != null && this.persistedDateOfPayment != null;
    },

    showPaymentRequestButton() {
      return this.form.payment_by_card && this.persisted && this.form.late;
    },

    sectionName() {
      return this.persisted
        ? `Editar Parcela - ${this.form.number}`
        : 'Novo Parcela';
    },

    anyError() {
      return !_.isEmpty(this.errors);
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    clearForm() {
      this.persistedDateOfPayment = null;
      this.form = {
        date: this.$moment().format('DD/MM/YYYY'),
        id: null,
        owner_id: null,
        owner_name: null,
        obs: null,
        members: [],
        amount: 0
      };
    },

    init() {
      if (this.$route.params.id) {
        this.fetch(this.$route.params.id);
      }
    },

    openHistory() {
      this.$refs.history.open();
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    _setErrors(errors) {
      this.errors = _.clone(errors || {});
      setTimeout(() => {
        $('.error.field').popup();
      }, 100);
    },

    requestPayment() {
      this.requestingPayment = true;
      Api.invoices
        .requestPayment(this.form.id)
        .then(response => {
          this._parseForm(response.data.invoice);
          this.$toast.show('Parcela paga com sucesso', 'success');
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show(error.response.data.errors.join(','), 'error');
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.requestingPayment = false;
        });
    },

    save() {
      this.loading = true;
      this._setErrors({});

      let data = this.form;
      data.contract_id = this.$route.params.contract_id;

      Api.invoices
        .save(data)
        .then(async response => {
          this.$toast.show('Parcela salvo com sucesso', 'success');
          this._parseForm(response.data.invoice);
        })
        .catch(error => {
          if (error.response) {
            const errors = error.response.data.errors;
            const baseErrors = errors && errors.base;
            if (baseErrors && baseErrors.length) {
              this.$toast.show(baseErrors.join(', '), 'error');
            } else {
              this.$toast.show('Erro ao salvar parcela', 'error');
            }
            this._setErrors(errors);
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    remove() {
      const removeIt = confirm('Remover Parcela?');
      if (removeIt) {
        this.loading = true;
        Api.invoices
          .destroy(this.form.id)
          .then(async () => {
            this.$toast.show('Parcela removido com sucesso', 'success');
            this.$router.push({
              name: 'contract_invoices',
              params: {
                contract_id: this.$route.params.contract_id
              }
            });
          })
          .catch(error => {
            if (error.response) {
              const errors = error.response.data.errors;
              const baseErrors = errors && errors.base;
              if (baseErrors && baseErrors.length) {
                this.$toast.show(baseErrors.join(', '), 'error');
              } else {
                this.$toast.show('Erro ao remover parcela', 'error');
              }
              this._setErrors(errors);
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      }
    },

    chargeback() {
      const confirmed = confirm('Estornar Parcela?');
      if (confirmed) {
        this.loading = true;
        Api.invoices
          .chargeback(this.form.id)
          .then(async response => {
            this.$toast.show('Parcela extornada com sucesso', 'success');
            this._parseForm(response.data.invoice);
          })
          .catch(error => {
            if (error.response) {
              const errors = error.response.data.errors;
              const baseErrors = errors && errors.base;
              if (baseErrors && baseErrors.length) {
                this.$toast.show(baseErrors.join(', '), 'error');
              } else {
                this.$toast.show('Erro ao estornar parcela', 'error');
              }
              this._setErrors(errors);
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      }
    },

    _parseForm(data) {
      data.due_date =
        data.due_date == null
          ? null
          : this.$moment(data.due_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      data.date_of_payment =
        data.date_of_payment == null
          ? null
          : this.$moment(data.date_of_payment, 'YYYY-MM-DD').format(
              'DD/MM/YYYY'
            );
      this.persistedDateOfPayment = data.date_of_payment;
      this.form = data;
    },

    fetch(id) {
      this.loading = true;
      Api.invoices
        .fetch(id)
        .then(async response => {
          this._parseForm(response.data.invoice);
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao buscar parcela', 'error');
            this.$router.go(-1);
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },
    updateAmont(value) {
      this.form.amount = value;
    }
  }
};
</script>

<style lang="css" scoped>
.warn {
  margin-right: 10px;
}
</style>
